/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Student_Verify_Unlock_TitleInputs */

const en_student_verify_unlock_title = /** @type {(inputs: Student_Verify_Unlock_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlock 60% off`)
};

const de_student_verify_unlock_title = /** @type {(inputs: Student_Verify_Unlock_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`60% Rabatt sichern`)
};

const fr_student_verify_unlock_title = /** @type {(inputs: Student_Verify_Unlock_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Débloque 60% de reduction`)
};

const es_student_verify_unlock_title = /** @type {(inputs: Student_Verify_Unlock_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desbloquea un 60% de descuento`)
};

const it_student_verify_unlock_title = /** @type {(inputs: Student_Verify_Unlock_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sblocca il 60% di sconto`)
};

const nl_student_verify_unlock_title = /** @type {(inputs: Student_Verify_Unlock_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ontgrendel 60% korting`)
};

const pl_student_verify_unlock_title = /** @type {(inputs: Student_Verify_Unlock_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odblokuj 60% znizki`)
};

const fi_student_verify_unlock_title = /** @type {(inputs: Student_Verify_Unlock_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avaa 60% alennus`)
};

const da_student_verify_unlock_title = /** @type {(inputs: Student_Verify_Unlock_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lås op for 60% rabat`)
};

const sv_student_verify_unlock_title = /** @type {(inputs: Student_Verify_Unlock_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lås upp 60% rabatt`)
};

/**
* | output |
* | --- |
* | "Unlock 60% off" |
*
* @param {Student_Verify_Unlock_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const student_verify_unlock_title = /** @type {((inputs?: Student_Verify_Unlock_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Student_Verify_Unlock_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_student_verify_unlock_title(inputs)
	if (locale === "fr") return fr_student_verify_unlock_title(inputs)
	if (locale === "es") return es_student_verify_unlock_title(inputs)
	if (locale === "it") return it_student_verify_unlock_title(inputs)
	if (locale === "nl") return nl_student_verify_unlock_title(inputs)
	if (locale === "pl") return pl_student_verify_unlock_title(inputs)
	if (locale === "fi") return fi_student_verify_unlock_title(inputs)
	if (locale === "da") return da_student_verify_unlock_title(inputs)
	if (locale === "sv") return sv_student_verify_unlock_title(inputs)
	return en_student_verify_unlock_title(inputs)
});